export interface PrescriptionStoreState {
  prescriptionId?: string
  practitioner?: { firstName: string; lastName: string, title?: string }
}

export enum PrescriptionActionTypes {
  SET_PRESCRIPTION_ID = 'SET_PRESCRIPTION_ID',
  SET_PRACTITIONER_INFO = 'SET_PRACTITIONER_INFO',
}
